import React from "react";

const Speed15StrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1245_188)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 11.841L19.182 8.65902",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 8.659L19.182 11.841",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.95714 14V6.224H1.70914C1.54114 7.04 0.773141 7.664 -0.342859 7.688V8.672H1.54114V14H2.95714ZM4.37567 13.1C4.37567 13.64 4.80767 14.072 5.34767 14.072C5.88767 14.072 6.33167 13.64 6.33167 13.1C6.33167 12.56 5.88767 12.116 5.34767 12.116C4.80767 12.116 4.37567 12.56 4.37567 13.1ZM7.29945 11.852C7.39545 13.076 8.54745 14.192 10.2275 14.192C12.0275 14.192 13.1555 12.968 13.1555 11.504C13.1555 9.872 12.0395 8.912 10.4915 8.912C9.93945 8.912 9.33945 9.104 9.00345 9.452L9.48345 7.484H12.7715V6.224H8.51145L7.55145 10.148L8.90745 10.64C9.18345 10.328 9.65145 10.1 10.2035 10.1C10.9955 10.1 11.7035 10.58 11.7035 11.54C11.7035 12.404 11.0435 12.956 10.2275 12.956C9.32745 12.956 8.71545 12.332 8.65545 11.504L7.29945 11.852Z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1245_188"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Speed15StrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;